<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="4"
      >
        <v-card outlined>
          <v-card-text class="text-center">
            <v-btn
              small
              class="warning"
              @click="$router.back()"
            >
              Back
            </v-btn>

            <v-btn
              class="info"
              small
              @click="
                $router.replace({
                  name: 'EditProduct',
                  params: { id: $route.params.id },
                })
              "
            >
              Edit
            </v-btn>
            <v-btn
              class="info"
              small
              @click="
                $router.replace({
                  name: 'EditProduct',
                  params: { id: $route.params.id + 1 },
                })
              "
            >
              Edit Next
            </v-btn>
          </v-card-text>
          <v-card-text class="warning d-flex justify-center">
            <v-img
              class="justify-center"
              :src="'/storage/' + product.image"
              lazy-src="/storage/default_img/no_image.png"
              aspect-ratio="1"
              max-width="100"
              max-height="100"
            />
          </v-card-text>
          <v-card-text>
            Product Information
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <th class="text-left">
                      Name
                    </th>
                    <td>{{ product.name }}</td>
                  </tr>
                  <tr>
                    <th class="text-left">
                      SKU
                    </th>
                    <td>{{ product.sku }}</td>
                  </tr>

                  <tr>
                    <th class="text-left">
                      Type
                    </th>
                    <td>{{ product.type }}</td>
                  </tr>
                  <tr>
                    <th class="text-left">
                      Unit Of Measure
                    </th>
                    <td>{{ product.unitOfMeasure }}</td>
                  </tr>
                  <tr>
                    <th class="text-left">
                      IMEI
                    </th>
                    <td>{{ product.imei }}</td>
                  </tr>
                  <tr>
                    <th class="text-left">
                      Serial Number
                    </th>
                    <td>{{ product.sNumber }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
        <v-card
          outlined
          class="mt-3"
        >
          <v-card-text>
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <th class="text-left">
                      Sale from Warehouse
                    </th>
                    <td>
                      <router-link
                        :to="{
                          name: 'WarehouseDetail',
                          params: { id: product.warehouseSaleFrom },
                        }"
                      >
                        #warehouse
                      </router-link>
                    </td>
                  </tr>
                  <tr>
                    <th class="text-left">
                      No of Stocks
                    </th>
                    <td>{{ stocks.length }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="8"
      >
        <!-- Product Variants -->
        <v-card
          v-if="product.type === 'Combo'"
          outlined
          class="mt-3"
        >
          <v-card-text>
            <h3>Variants</h3>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Display Name
                    </th>
                    <th class="text-left">
                      Variant
                    </th>
                    <th class="text-left">
                      Additional Price
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in product.variants"
                    :key="item.name"
                  >
                    <td>{{ product.name }}( {{ item.variant }} )</td>
                    <td>{{ item.variant }}</td>
                    <td>{{ item.price | currency }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
        <!-- end -->

        <!-- Product Suppliers list -->
        <v-card outlined>
          <v-card-text>
            <h3>Product Suppliers</h3>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Name
                    </th>
                    <th class="text-left">
                      email
                    </th>
                    <th class="text-left">
                      Phone
                    </th>
                    <th class="text-left">
                      More
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in suppliers"
                    :key="item.name"
                  >
                    <td>{{ item.firstName }}</td>
                    <td>{{ item.email }}</td>
                    <td>{{ item.phone }}</td>
                    <td>
                      <router-link
                        :to="{
                          name: 'SupplierDetail',
                          params: { id: item.id },
                        }"
                      >
                        #supplier
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
        <!-- end -->

        <!-- Product has stocks -->
        <v-card
          v-if="stocks.length"
          outlined
          class="mt-3"
        >
          <v-card-text>
            <h3>Product Stocks</h3>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Warehouse
                    </th>
                    <th>Cost</th>
                    <th>Price</th>
                    <th>Qty</th>
                    <th>Sold</th>
                    <th>Returned</th>
                    <th>Rack</th>
                    <th>Active</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="stock in stocks"
                    :key="stock.name"
                    :class="stock.quantity < 1 ? 'green--text' : ''"
                  >
                    <td>
                      <router-link
                        :to="{
                          name: 'WarehouseDetail',
                          params: { id: stock.warehouse_id },
                        }"
                      >
                        {{ stock.warehouse.name | uppercase }}
                      </router-link>
                    </td>
                    <td>{{ stock.cost | currency }}</td>
                    <td>{{ stock.price | currency }}</td>
                    <td>{{ stock.quantity }}</td>
                    <th>{{ stock.sold }}</th>
                    <th>{{ stock.returned }}</th>
                    <td>{{ stock.rackNumber }}</td>
                    <td>
                      <template v-if="stock.quantity > 0">
                        <v-tooltip
                          v-if="
                            stock.warehouse_id === product.warehouseSaleFrom
                          "
                          right
                          bottom
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              color="success"
                              dark
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-check-circle
                            </v-icon>
                          </template>
                          <span>Activated</span>
                        </v-tooltip>

                        <v-tooltip
                          v-else
                          right
                          bottom
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              color="info"
                              dark
                              v-bind="attrs"
                              @click="setForSale(stock.warehouse_id)"
                              v-on="on"
                            >
                              mdi-shuffle-variant
                            </v-icon>
                          </template>
                          <span>Activate for sale</span>
                        </v-tooltip>
                      </template>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
        <!-- end -->

        <v-card
          v-else
          outlined
          class="mt-2"
        >
          <v-card-text>
            <h3>Selling on Basic (No purchased stock)</h3>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Available Qty
                    </th>
                    <th class="text-left">
                      Unit Cost
                    </th>
                    <th class="text-left">
                      Unit Price
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ product.qty }}</td>
                    <td>{{ product.cost | currency }}</td>
                    <td>{{ product.price | currency }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-col>
      <h4>Description</h4>
      <v-card
        outlined
        class="mt-2"
      >
        <v-card-text>
          <div v-html="product.description" />
        </v-card-text>
      </v-card>
    </v-col>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      product: {},
      suppliers: {},
      stocks: {},
    };
  },
  mounted() {
    if (this.$route.params.id) {
      window.axios.get("/product/" + this.$route.params.id).then((response) => {
        this.$data.product = response.data.product;
        this.$data.suppliers = response.data.product.suppliers;
        this.$data.stocks = response.data.stocks;
      });
    }
  },
  methods: {
    ...mapActions({
      alert: "snackbar/show",
    }),
    setForSale(id) {
      window.axios
        .post("/set-for-sale/" + this.$data.product.id, { warehouse_id: id })
        .then((response) => {
          this.$data.product.warehouseSaleFrom = id;
          this.alert(response.data.message);
        });
    },
  },
};
</script>
